// components/ShareModal.js
// components/ShareModal.js
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { formatAddress } from "../../../helper";
import {
    TwitterShareButton,
    TelegramShareButton,
    WhatsappShareButton,
    EmailShareButton,
    FacebookShareButton,
} from "react-share";
import { root } from "viem/chains";
import { useTheme } from "../../../hooks/ThemeProvider";

const ShareModal = ({ show, onHide, rootPoolData, trxHash, link }) => {
    let hash = rootPoolData?._id;

    const [copied, setCopied] = useState(false);
    const poolLink = `${window.location.origin}/${link}/${hash}`;

    const handleCopy = () => {
        navigator.clipboard.writeText(poolLink).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };
    const { theme, toggle } = useTheme();
    return (
        <Modal className="stakingmodal" show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Share</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="modal_share">
                    <div className="inner_type">
                        <div className="one_modal">
                            <img
                                src={rootPoolData?.projectLogo ? rootPoolData?.projectLogo : rootPoolData?.rootPoolId?.projectLogo || "/assets/imgsmodal.svg"}
                                className="imgmodal"
                                alt="Pool"
                            />
                            <h3 className="text-light">{rootPoolData?.projectName ? rootPoolData?.projectName : rootPoolData?.rootPoolId?.projectName}</h3>
                            <p>{rootPoolData?.tagline ? rootPoolData?.tagline : rootPoolData?.rootPoolId?.taglinne}</p>
                        </div>

                        <div className="copy_buttons">
                            <div>
                                <p>Unique URL</p>
                                <span>{formatAddress(poolLink)}</span>
                            </div>
                           <button onClick={handleCopy}>
  {copied ? (
    // ✅ Checkmark SVG (after copy)
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path d="M11.6667 3.5L5.25001 9.91667L2.33334 7" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  ) : (
    // 📄 Copy SVG (default)
    <svg className="ticccksvg" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <g clipPath="url(#clip0_59_4779)">
        <path d="M11.6667 4.66663H5.83332C5.18899 4.66663 4.66666 5.18896 4.66666 5.83329V11.6666C4.66666 12.311 5.18899 12.8333 5.83332 12.8333H11.6667C12.311 12.8333 12.8333 12.311 12.8333 11.6666V5.83329C12.8333 5.18896 12.311 4.66663 11.6667 4.66663Z" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2.33332 9.33329C1.69166 9.33329 1.16666 8.80829 1.16666 8.16663V2.33329C1.16666 1.69163 1.69166 1.16663 2.33332 1.16663H8.16666C8.80833 1.16663 9.33333 1.69163 9.33333 2.33329" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_59_4779">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )}

  {copied ? "Copied!" : "Copy"}
</button>

                        </div>

                        <div className="social_div">
                            <h5>Share via Socials</h5>
                            <div className="social_icons">
                                <TwitterShareButton url={poolLink} title={rootPoolData?.tagline}>

                                    {
                                        theme === 'dark' ? <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="39"
                                            height="38"
                                            viewBox="0 0 39 38"
                                            fill="none"
                                        >
                                            <rect
                                                x="0.363647"
                                                width="38"
                                                height="38"
                                                rx="12"
                                                fill="#0F1E40"
                                            />
                                            <path
                                                d="M23.5463 11.7273H25.7766L20.9039 17.8886L26.6363 26.2727H22.1479L18.6324 21.1878L14.6098 26.2727H12.3781L17.59 19.6826L12.0909 11.7273H16.6932L19.871 16.3751L23.5463 11.7273ZM22.7634 24.7959H23.9993L16.0217 13.1266H14.6955L22.7634 24.7959Z"
                                                fill="white"
                                            />
                                        </svg> :
                                            <svg xmlns="http://www.w3.org/2000/svg" width="39" height="38" viewBox="0 0 39 38" fill="none">
                                                <rect x="0.363281" width="38" height="38" rx="12" fill="#EFF0F9" />
                                                <path d="M23.5462 11.7273H25.7766L20.9038 17.8886L26.6363 26.2727H22.1478L18.6323 21.1878L14.6098 26.2727H12.378L17.59 19.6826L12.0908 11.7273H16.6932L19.8709 16.3751L23.5462 11.7273ZM22.7634 24.7959H23.9993L16.0217 13.1266H14.6954L22.7634 24.7959Z" fill="#000F2F" />
                                            </svg>
                                    }


                                </TwitterShareButton>

                                <TelegramShareButton url={poolLink} title={rootPoolData?.tagline}>
                                          {
                theme === 'dark' ?      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="39"
                                        height="38"
                                        viewBox="0 0 39 38"
                                        fill="none"
                                    >
                                        <rect
                                            x="0.181824"
                                            width="38"
                                            height="38"
                                            rx="12"
                                            fill="#0F1E40"
                                        />
                                        <path
                                            d="M25.2765 11.8229L9.81514 17.7472C8.75997 18.1683 8.76607 18.7532 9.62155 19.014L13.5911 20.2445L22.7755 14.4866C23.2098 14.224 23.6065 14.3652 23.2804 14.6529L15.8392 21.3258H15.8375L15.8392 21.3267L15.5654 25.3923C15.9666 25.3923 16.1436 25.2095 16.3686 24.9937L18.2967 23.1308L22.3072 26.0743C23.0467 26.4789 23.5778 26.271 23.7618 25.3941L26.3945 13.0655C26.6639 11.9919 25.982 11.5058 25.2765 11.8229Z"
                                            fill="white"
                                        />
                                    </svg> :
                  <svg xmlns="http://www.w3.org/2000/svg" width="39" height="38" viewBox="0 0 39 38" fill="none">
  <rect x="0.181641" width="38" height="38" rx="12" fill="#EFF0F9"/>
  <path d="M25.2764 11.8229L9.81502 17.7472C8.75984 18.1683 8.76595 18.7532 9.62143 19.014L13.591 20.2445L22.7754 14.4866C23.2096 14.224 23.6064 14.3652 23.2803 14.6529L15.8391 21.3258H15.8374L15.8391 21.3267L15.5653 25.3923C15.9664 25.3923 16.1435 25.2095 16.3684 24.9937L18.2965 23.1308L22.3071 26.0743C23.0466 26.4789 23.5776 26.271 23.7616 25.3941L26.3944 13.0655C26.6638 11.9919 25.9819 11.5058 25.2764 11.8229Z" fill="#000F2F"/>
</svg>
              }


                                </TelegramShareButton>

                                <WhatsappShareButton url={poolLink} title={rootPoolData?.tagline}>
                                          {
                theme === 'dark' ?       <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="39"
                                        height="38"
                                        viewBox="0 0 39 38"
                                        fill="none"
                                    >
                                        <rect
                                            x="0.818176"
                                            width="38"
                                            height="38"
                                            rx="12"
                                            fill="#0F1E40"
                                        />
                                        <path
                                            d="M20.1429 10.125C15.8729 10.125 12.411 13.5598 12.411 17.7972C12.411 19.2467 12.8164 20.6023 13.5205 21.7589L12.1251 25.875L16.4058 24.5151C17.5135 25.1228 18.7875 25.4694 20.1429 25.4694C24.4134 25.4694 27.8751 22.0341 27.8751 17.7972C27.8751 13.5598 24.4134 10.125 20.1429 10.125ZM23.9876 20.7109C23.8057 21.1618 22.9831 21.5734 22.6201 21.5923C22.2575 21.6116 22.2471 21.8734 20.2702 21.0146C18.2936 20.1556 17.1043 18.0669 17.0106 17.9324C16.9168 17.7984 16.2449 16.8409 16.2811 15.8774C16.3176 14.9136 16.8453 14.459 17.0336 14.2699C17.2217 14.0805 17.4374 14.0465 17.5691 14.0444C17.7248 14.0419 17.8256 14.0398 17.9408 14.044C18.0559 14.0484 18.2288 14.0199 18.3785 14.418C18.5281 14.8161 18.8863 15.7945 18.9321 15.8942C18.9779 15.994 19.0062 16.1096 18.9357 16.2377C18.8649 16.3661 18.8287 16.4464 18.7261 16.557C18.6229 16.6677 18.509 16.8046 18.417 16.8892C18.3144 16.9829 18.2071 17.0851 18.3151 17.2854C18.4229 17.4856 18.795 18.1417 19.362 18.6824C20.0906 19.3775 20.7189 19.608 20.9123 19.7131C21.1062 19.8187 21.2219 19.8069 21.3421 19.6804C21.4618 19.5539 21.8568 19.1268 21.9959 18.9362C22.1349 18.745 22.2652 18.7824 22.4438 18.8543C22.6224 18.9264 23.5744 19.4363 23.7683 19.5416C23.962 19.6467 24.0915 19.7009 24.1378 19.7842C24.1841 19.8679 24.1695 20.2599 23.9876 20.7109Z"
                                            fill="white"
                                        />
                                    </svg> :
                 <svg xmlns="http://www.w3.org/2000/svg" width="39" height="38" viewBox="0 0 39 38" fill="none">
  <rect x="0.817383" width="38" height="38" rx="12" fill="#EFF0F9"/>
  <path d="M20.1418 10.125C15.8719 10.125 12.41 13.5598 12.41 17.7972C12.41 19.2467 12.8154 20.6023 13.5195 21.7589L12.124 25.875L16.4048 24.5151C17.5125 25.1228 18.7864 25.4694 20.1418 25.4694C24.4124 25.4694 27.874 22.0341 27.874 17.7972C27.874 13.5598 24.4124 10.125 20.1418 10.125ZM23.9866 20.7109C23.8047 21.1618 22.982 21.5734 22.619 21.5923C22.2564 21.6116 22.2461 21.8734 20.2692 21.0146C18.2925 20.1556 17.1033 18.0669 17.0095 17.9324C16.9157 17.7984 16.2438 16.8409 16.2801 15.8774C16.3166 14.9136 16.8442 14.459 17.0326 14.2699C17.2207 14.0805 17.4364 14.0465 17.5681 14.0444C17.7237 14.0419 17.8246 14.0398 17.9398 14.044C18.0549 14.0484 18.2278 14.0199 18.3775 14.418C18.5271 14.8161 18.8852 15.7945 18.931 15.8942C18.9768 15.994 19.0052 16.1096 18.9346 16.2377C18.8639 16.3661 18.8277 16.4464 18.7251 16.557C18.6219 16.6677 18.508 16.8046 18.416 16.8892C18.3133 16.9829 18.2061 17.0851 18.314 17.2854C18.4219 17.4856 18.794 18.1417 19.3609 18.6824C20.0896 19.3775 20.7179 19.608 20.9113 19.7131C21.1051 19.8187 21.2208 19.8069 21.3411 19.6804C21.4608 19.5539 21.8557 19.1268 21.9948 18.9362C22.1339 18.745 22.2642 18.7824 22.4428 18.8543C22.6213 18.9264 23.5733 19.4363 23.7672 19.5416C23.961 19.6467 24.0904 19.7009 24.1367 19.7842C24.183 19.8679 24.1684 20.2599 23.9866 20.7109Z" fill="#000F2F"/>
</svg>
              }


                                </WhatsappShareButton>

                                <EmailShareButton url={poolLink} subject={rootPoolData?.projectName} body={rootPoolData?.tagline}>

                                        {
                theme === 'dark' ?
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="39"
                                        height="38"
                                        viewBox="0 0 39 38"
                                        fill="none"
                                    >
                                        <rect
                                            x="0.636353"
                                            width="38"
                                            height="38"
                                            rx="12"
                                            fill="#0F1E40"
                                        />
                                        <path
                                            d="M24.6364 11H14.6364C13.3108 11.0016 12.0399 11.5289 11.1026 12.4662C10.1652 13.4036 9.63794 14.6744 9.63635 16V22C9.63794 23.3256 10.1652 24.5964 11.1026 25.5338C12.0399 26.4711 13.3108 26.9984 14.6364 27H24.6364C25.9619 26.9984 27.2328 26.4711 28.1701 25.5338C29.1075 24.5964 29.6348 23.3256 29.6364 22V16C29.6348 14.6744 29.1075 13.4036 28.1701 12.4662C27.2328 11.5289 25.9619 11.0016 24.6364 11ZM26.2674 15.775L22.1884 19.1C21.4666 19.6835 20.5665 20.0019 19.6384 20.0019C18.7102 20.0019 17.8101 19.6835 17.0884 19.1L13.0054 15.775C12.8102 15.6045 12.6889 15.3648 12.667 15.1065C12.645 14.8483 12.7243 14.5916 12.8879 14.3906C13.0515 14.1896 13.2868 14.06 13.5442 14.0291C13.8015 13.9982 14.0608 14.0685 14.2674 14.225L18.3474 17.546C18.7121 17.8412 19.1671 18.0022 19.6364 18.0022C20.1056 18.0022 20.5606 17.8412 20.9254 17.546L25.0054 14.225C25.1064 14.1367 25.2243 14.0696 25.3519 14.0278C25.4794 13.9859 25.6141 13.9702 25.7479 13.9816C25.8817 13.9929 26.0118 14.0311 26.1305 14.0938C26.2492 14.1565 26.3541 14.2425 26.4388 14.3466C26.5236 14.4507 26.5865 14.5708 26.6239 14.6998C26.6612 14.8288 26.6722 14.9639 26.6562 15.0972C26.6402 15.2305 26.5976 15.3592 26.5307 15.4757C26.4639 15.5921 26.3744 15.6939 26.2674 15.775Z"
                                            fill="white"
                                        />
                                    </svg> :
                 <svg xmlns="http://www.w3.org/2000/svg" width="39" height="38" viewBox="0 0 39 38" fill="none">
  <rect x="0.635742" width="38" height="38" rx="12" fill="#EFF0F9"/>
  <path d="M24.6357 11H14.6357C13.3101 11.0016 12.0393 11.5289 11.102 12.4662C10.1646 13.4036 9.63733 14.6744 9.63574 16V22C9.63733 23.3256 10.1646 24.5964 11.102 25.5338C12.0393 26.4711 13.3101 26.9984 14.6357 27H24.6357C25.9613 26.9984 27.2322 26.4711 28.1695 25.5338C29.1069 24.5964 29.6342 23.3256 29.6357 22V16C29.6342 14.6744 29.1069 13.4036 28.1695 12.4662C27.2322 11.5289 25.9613 11.0016 24.6357 11ZM26.2667 15.775L22.1877 19.1C21.466 19.6835 20.5659 20.0019 19.6377 20.0019C18.7096 20.0019 17.8095 19.6835 17.0877 19.1L13.0047 15.775C12.8096 15.6045 12.6883 15.3648 12.6663 15.1065C12.6444 14.8483 12.7236 14.5916 12.8873 14.3906C13.0509 14.1896 13.2862 14.06 13.5436 14.0291C13.8009 13.9982 14.0602 14.0685 14.2667 14.225L18.3467 17.546C18.7115 17.8412 19.1665 18.0022 19.6357 18.0022C20.105 18.0022 20.56 17.8412 20.9247 17.546L25.0047 14.225C25.1058 14.1367 25.2237 14.0696 25.3513 14.0278C25.4788 13.9859 25.6135 13.9702 25.7473 13.9816C25.8811 13.9929 26.0112 14.0311 26.1299 14.0938C26.2486 14.1565 26.3535 14.2425 26.4382 14.3466C26.523 14.4507 26.5859 14.5708 26.6233 14.6998C26.6606 14.8288 26.6716 14.9639 26.6556 15.0972C26.6396 15.2305 26.5969 15.3592 26.5301 15.4757C26.4633 15.5921 26.3737 15.6939 26.2667 15.775Z" fill="#000F2F"/>
</svg>
              }

                                </EmailShareButton>

                                {/* <DiscordShareButton url={poolLink} quote={rootPoolData?.tagline}>
                                    <img src="/icons/facebook.svg" alt="Facebook" />
                                </DiscordShareButton> */}
                            </div>
                        </div>
                    </div>

                    <div className="buton_modal_div">
                        <button onClick={onHide}>Close</button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ShareModal;



